<astrea-internal-banner
    title="{{ 'pages.materias.title' | translate }}"
></astrea-internal-banner>

<div class="astrea-materias content-height p-sm-4 p-2">
    <div class="container">

        <form [formGroup]="formSearch">
            <mat-form-field class="w-25 mr-3" appearance="fill">
                <mat-label>{{ 'pages.materias.search' | translate }}</mat-label>
                <input type="text" matInput formControlName="materia" (ngModelChange)="filterMaterias($event)">
            </mat-form-field>
        </form>

        <div *ngIf="!loading; else astreaLoading">

            <ul *ngIf="materias && materias.length > 0; else withoutResults" class="p-0">
                <li *ngFor="let m of materias" class="astrea-materia-item d-flex j-c-start a-i-center animated astreaFade">
                    <img
                        class="image mr-2"
                        src="/assets/images/icons/materias.png"
                        alt="{{ m.legalMatter }}"
                    >
                    <a [routerLink]="['/materia', m.url]" title="{{ m.legalMatter | uppercase }}" class="d-flex j-c-start a-i-center py-2">
                        <div class="d-flex flex-column">
                            <h2>{{ m.legalMatter }}</h2>
                        </div>
                    </a>
                </li>
            </ul>

        </div>

        <ng-template #withoutResults>
            <div class="t-center">
                {{ 'pages.materias.without' | translate }}
            </div>
        </ng-template>

        <ng-template #astreaLoading>
            <astrea-loading
                [text]="'pages.materias.loading' | translate"
            ></astrea-loading>
        </ng-template>

    </div>
</div>
